import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(Authentication)/register/page.tsx");
